
export const CONTA_AGRARE = 'CONTA_AGRARE';
export const CONTA_AGRARE_PENDING = 'CONTA_AGRARE_PENDING';
export const CONTA_AGRARE_SUCCESS = 'CONTA_AGRARE_SUCCESS';
export const CONTA_AGRARE_FAILURE = 'CONTA_AGRARE_FAILURE';

export const TABLE_CONTA_AGRARE = 'TABLE_CONTA_AGRARE';
export const TABLE_CONTA_AGRARE_PENDING = 'TABLE_CONTA_AGRARE_PENDING';
export const TABLE_CONTA_AGRARE_SUCCESS = 'TABLE_CONTA_AGRARE_SUCCESS';
export const TABLE_CONTA_AGRARE_FAILURE = 'TABLE_CONTA_AGRARE_FAILURE';

export const FIND_CONTA_AGRARE = 'FIND_CONTA_AGRARE';
export const FIND_CONTA_AGRARE_PENDING = 'FIND_CONTA_AGRARE_PENDING';
export const FIND_CONTA_AGRARE_SUCCESS = 'FIND_CONTA_AGRARE_SUCCESS';
export const FIND_CONTA_AGRARE_FAILURE = 'FIND_CONTA_AGRARE_FAILURE';

export const UPDATE_CONTA_AGRARE = 'UPDATE_CONTA_AGRARE';
export const UPDATE_CONTA_AGRARE_PENDING = 'UPDATE_CONTA_AGRARE_PENDING';
export const UPDATE_CONTA_AGRARE_SUCCESS = 'UPDATE_CONTA_AGRARE_SUCCESS';
export const UPDATE_CONTA_AGRARE_FAILURE = 'UPDATE_CONTA_AGRARE_FAILURE';

export const DELETE_CONTA_AGRARE = 'DELETE_CONTA_AGRARE';
export const DELETE_CONTA_AGRARE_PENDING = 'DELETE_CONTA_AGRARE_PENDING';
export const DELETE_CONTA_AGRARE_SUCCESS = 'DELETE_CONTA_AGRARE_SUCCESS';
export const DELETE_CONTA_AGRARE_FAILURE = 'DELETE_CONTA_AGRARE_FAILURE';

export const NEW_FILTER_CONTA_AGRARE = 'NEW_FILTER_CONTA_AGRARE'
export const NEW_FILTER_CONTA_AGRARE_PEDING = 'NEW_FILTER_CONTA_AGRARE_PEDING'
export const NEW_FILTER_CONTA_AGRARE_SUCCESS = 'NEW_FILTER_CONTA_AGRARE_SUCCESS'
export const NEW_FILTER_CONTA_AGRARE_FAILURE = 'NEW_FILTER_CONTA_AGRARE_FAILURE'

export const NEW_FILTER_NEXT_PAGE_CONTA_AGRARE = 'NEW_FILTER_NEXT_PAGE_CONTA_AGRARE'
export const NEW_FILTER_NEXT_PAGE_CONTA_AGRARE_PENDING = 'NEW_FILTER_NEXT_PAGE_CONTA_AGRARE_PENDING'
export const NEW_FILTER_NEXT_PAGE_CONTA_AGRARE_SUCCESS = 'NEW_FILTER_NEXT_PAGE_CONTA_AGRARE_SUCCESS'
export const NEW_FILTER_NEXT_PAGE_CONTA_AGRARE_FAILURE = 'NEW_FILTER_NEXT_PAGE_CONTA_AGRARE_FAILURE'

export const UPDATE_DATA_ULT_ACESSO_CONTA_AGRARE = 'UPDATE_DATA_ULT_ACESSO_CONTA_AGRARE'
export const UPDATE_DATA_ULT_ACESSO_CONTA_AGRARE_PENDING = 'UPDATE_DATA_ULT_ACESSO_CONTA_AGRARE_PENDING'
export const UPDATE_DATA_ULT_ACESSO_CONTA_AGRARE_SUCCESS = 'UPDATE_DATA_ULT_ACESSO_CONTA_AGRARE_SUCCESS'
export const UPDATE_DATA_ULT_ACESSO_CONTA_AGRARE_FAILURE = 'UPDATE_DATA_ULT_ACESSO_CONTA_AGRARE_FAILURE'

export const BLOQUEAR_CONTA_AGRARE = 'BLOQUEAR_CONTA_AGRARE';
export const BLOQUEAR_CONTA_AGRARE_PENDING = 'BLOQUEAR_CONTA_AGRARE_PENDING';
export const BLOQUEAR_CONTA_AGRARE_SUCCESS = 'BLOQUEAR_CONTA_AGRARE_SUCCESS';
export const BLOQUEAR_CONTA_AGRARE_FAILURE = 'BLOQUEAR_CONTA_AGRARE_FAILURE';

export const DESBLOQUEAR_CONTA_AGRARE = 'DESBLOQUEAR_CONTA_AGRARE';
export const DESBLOQUEAR_CONTA_AGRARE_PENDING = 'DESBLOQUEAR_CONTA_AGRARE_PENDING';
export const DESBLOQUEAR_CONTA_AGRARE_SUCCESS = 'DESBLOQUEAR_CONTA_AGRARE_SUCCESS';
export const DESBLOQUEAR_CONTA_AGRARE_FAILURE = 'DESBLOQUEAR_CONTA_AGRARE_FAILURE';

export const PRORROGAR_TESTE_CONTA_AGRARE = 'PRORROGAR_TESTE_CONTA_AGRARE';
export const PRORROGAR_TESTE_CONTA_AGRARE_PENDING = 'PRORROGAR_TESTE_CONTA_AGRARE_PENDING';
export const PRORROGAR_TESTE_CONTA_AGRARE_SUCCESS = 'PRORROGAR_TESTE_CONTA_AGRARE_SUCCESS';
export const PRORROGAR_TESTE_CONTA_AGRARE_FAILURE = 'PRORROGAR_TESTE_CONTA_AGRARE_FAILURE';

export const LIBERAR_CONTA_AGRARE = 'LIBERAR_CONTA_AGRARE';
export const LIBERAR_CONTA_AGRARE_PENDING = 'LIBERAR_CONTA_AGRARE_PENDING';
export const LIBERAR_CONTA_AGRARE_SUCCESS = 'LIBERAR_CONTA_AGRARE_SUCCESS';
export const LIBERAR_CONTA_AGRARE_FAILURE = 'LIBERAR_CONTA_AGRARE_FAILURE';
